import React from "react";
import Navbar from "../components/navbar";
import '../style.css';
// import Thumbnail1 from "../assets/disney-fantasy-aquaduck-from-above-int2cruises.webp"
// import Thumbnail2 from "../assets/first-time-cruises-int2cruises-blog.jpg";
// import Thumbnail3 from "../assets/eastmed_destination-int2cruises.jpg";
// import Thumbnail4 from "../assets/Iceland_valcano_burfell_Int2Cruises.jpg";
import Thumbnail1 from "../assets/4.jpg"
import Thumbnail2 from "../assets/2.jpg";
import Thumbnail3 from "../assets/1.jpg";
import Thumbnail4 from "../assets/3.jpg";
import Thumbnail5 from "../assets/Thumbnail_5.jpg";
import News1 from "../assets/news1.png";
import News2 from "../assets/news2.png";
import News3 from "../assets/news3.png";
import News4 from "../assets/news4.png";
import News5 from "../assets/news5.png";
import News6 from "../assets/news6.png";
import News7 from "../assets/news7.png";
import News8 from "../assets/news8.png";
import News9 from "../assets/news9.png";
import News10 from "../assets/news10.png";
import News11 from "../assets/news11.png";
import News12 from "../assets/news12.png";
import News13 from "../assets/news13.png";
import News14 from "../assets/news14.png";
import News15 from "../assets/news15.png";
import News16 from "../assets/news16.png";
import News17 from "../assets/news_1206.png";
import ScrolltoTop from "../components/ScrolltoTop";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import UTMHandler from "../components/UTMHandler";
import AutoShowModal from "../components/AutoShowModal";
import { Helmet } from "react-helmet";


const blogPosts = [
  {
    title: "Six ways to find the cheapest cruise deals",
    excerpt: "Timing is everything. If you are looking to book a popular cruise itinerary during ....",
    image: Thumbnail1,
    link:"/six-ways-to-find-the-cheapest-cruise-deals"
  },
  {
    title: "5 Things First-Time Cruisers Must Know Before Booking Their Cruise Holiday",
    excerpt: "Before you dive in and book your dream vacation at sea, here ...",
    image: Thumbnail2,
     link:"/5-things-first-time-cruisers-must-know-before-booking-their-cruise-holiday"
  },
  {
    title: "Top 4 Upcoming European Summer Cruises in 2025",
    excerpt: "From sun-soaked Mediterranean towns to the mystical fjords of the north...",
    image: Thumbnail3,
    link:"/top-4-european-summer-cruises-coming-in-2025"
  }, 
  {
    title: "Top 5 Northern Europe Cruises in 2025",
    excerpt: "A Northern Europe cruise is not just a holiday. It&#39;s an entrance to centuries of maritime history, glacial landscapes, and ....",
    image: Thumbnail4,
    link:"/top-5-northern-europe-cruises-in-2025"
  }, 
  {
    title: "5 Truths you didn’t know about cruising ",
    excerpt: "It’s time to unpack the biggest misconceptions about cruising—and show why now is the time to sail beyond them....",
    image: Thumbnail5,
    link:"/5-Truths-you-didn’t-know-about-cruising"
  }
]

const Blog = () => {
return(
    <>
 <UTMHandler/>

 <Helmet>
              <title>Cruise Travel Blog – Tips, Guides & News - Int2Cruises</title>
              <meta name="description" content="Read expert cruise travel tips, destination guides, and news. Stay updated with cruise trends and plan smarter with insider advice." />
            </Helmet>

    <div className="about-navbar">
        <Navbar/>
    </div>


      

        <div className="blog-container">
            <div className="blog-header" >
        <h1>Media & Blog</h1>
        </div>
            <div className="blog-main-grid">

              <div>

                <div className="blog-grid">
                 
      {blogPosts.map((post, index) => (
        <div className="blog-card" key={index}>
          <img src={post.image} alt={post.title} />
          <h3>{post.title}</h3>
          <p>{post.excerpt}</p>
         <Link to={post.link}>
          <button className="read-more-btn">Read More</button>
          </Link>
        </div>
      ))}


    </div>

    <div className="news-container">

         <div><h3>Media</h3></div>
          <a href="https://www.moneycontrol.com/travel/anchors-aweigh-indias-cruise-craze-record-footfalls-draw-singapore-ota-to-its-shores-article-13061501.html" target="_blank" rel="noreferrer"> <img src={News9} alt="Latest News -Int2cruises.com"/></a>
      
          <a href="https://www.cnbctv18.com/travel/destinations/short-haul-cruise-tourism-rises-in-india-int2cruises-could-simplify-your-holiday-bookings-19612050.htm" target="_blank" rel="noreferrer"><img src={News1} alt="Latest News -Int2cruises.com"/></a>
           <a href="https://travelbizmonitor.com/top-stories/asias-cruise-first-ota-int2cruises-makes-india-debut/" target="_blank" rel="noreferrer"><img src={News8} alt="Latest News -Int2cruises.com"/></a>
           <a href="https://www.hotelierindia.com/development/int2cruises-sets-sail-in-india-simplifying-cruise-holidays-for-modern-travellers" target="_blank" rel="noreferrer"><img src={News13} alt="Latest News -Int2cruises.com"/></a>
      
          </div>

    
</div>

     


     <aside className="sidebar">
        {/* <input className="search-input" placeholder="Search..." /> */}
        <div className="widget">
          <h4>Latest Media</h4>
          {/* <ul>
            <li>New cruise routes launched</li>
            <li>COVID travel update</li>
            <li>Winter packages</li>
          </ul> */}

          
        </div>
        <div className="widget">
  
          <a href="https://www.hindustantimes.com/lifestyle/travel/going-on-a-cruise-for-the-first-time-know-10-beginner-friendly-travel-hacks-and-mistakes-to-avoid-on-board-101749714127695.html" target="_blank" rel="noreferrer"><img src={News17} alt="Latest News -Int2cruises.com"/></a>
          <a href="http://travel.economictimes.indiatimes.com/amp/news/tourism/cruise/int2cruises-launches-in-india-revolutionizing-cruise-booking-for-indian-travellers/121437716" target="_blank" rel="noreferrer"><img src={News2} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.businesstraveller.com/business-travel/2025/05/28/asias-first-cruise-focused-ota-int2cruises-sets-sail-in-india/" target="_blank" rel="noreferrer"><img src={News3} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.theweek.in/wire-updates/business/2025/05/28/dcm87-biz-int2cruises.amp.html" target="_blank" rel="noreferrer"><img src={News4} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.travelandtourworld.com/news/article/int2cruises-debuts-in-mumbai-transforming-cruise-travel-with-end-to-end-solutions-to-premier-destinations-like-singapore-dubai-japan-and-more/" target="_blank" rel="noreferrer"><img src={News5} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://money.rediff.com/news/market/int2cruises-launches-cruise-platform-in-india/27656020250528" target="_blank" rel="noreferrer"><img src={News6} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.traveltrendstoday.in/int2cruises-officially-launches-in-india/" target="_blank" rel="noreferrer"><img src={News7} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.ptinews.com/story/business/online-travel-platform-int2cruises-enters-indian-market/2596097" target="_blank" rel="noreferrer"><img src={News10} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://travelworldonline.in/int2cruises-launches-in-india-to-revolutionise-cruise-booking-with-all-in-one-digital-travel-platform/" target="_blank" rel="noreferrer"><img src={News11} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.bwtravel.com/industry-insights/india-welcomes-asias-first-cruise-focused-online-travel-platform-9310401" target="_blank" rel="noreferrer"><img src={News12} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://travelspan.in/asias-first-cruise-focused-ota-int2cruises-sets-sail-in-india/" target="_blank" rel="noreferrer"><img src={News14} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://www.tboacademy.com/blog/int2cruises-launches-in-india-to-revolutionize-cruise-bookings/" target="_blank" rel="noreferrer"><img src={News15} alt="Latest News -Int2cruises.com"/></a>
          <a href="https://traveltradejournal.com/asias-cruise-first-ota-int2cruises-launches-in-india/" target="_blank" rel="noreferrer"><img src={News16} alt="Latest News -Int2cruises.com"/></a>
          {/* <h4>Latest Blogs</h4>
          <ul>
            <li>Cruise</li>
            <li>Luxury</li>
            <li>Adventure</li>
            <li>Tips</li>
          </ul> */}
        </div>
      </aside>



                
              
            </div>

            
        </div>

        <ScrolltoTop/>
        <AutoShowModal/>
        <Footer/>

    </>
 );
}

export default Blog ;